export default "__VITE_ASSET__DomYvyF___"